<template>
  <div>
    <div>
      <b-card bg-variant="danger" text-variant="white" header="Fatal error" class="text-center">
        
        <div class="w-100 text-center">
            <br><br><br>
            <h2>
                A fatal error has occurred.
            </h2>
            <br><br>
            <p>
                This can be caused by invalid data, a changed system state, or another error.
            <br>
                Try again. If the problem persists, contact support.
            <br>
                Thank you.
            </p>
            <!--<b-button
                variant="primary"
                class="mb-2 btn-sm-block"
                :to="{ name: 'default-view', params: { }}"
            >
                Back home
            </b-button>-->
            <p class="bg-warning text-dark" v-html="error.message"></p>
            <br><br><br>
        </div>

      </b-card>
    </div>
  </div>
</template>

<script>
import { state/*, mutations*/ } from '@/store/index.js'

export default {
  components: { },

  computed: {
    error( ) {
        return state.error
    }
  },

  data( ) {
    return {
    }
  },

  mounted( ) { },

  methods: { }
}
</script>

<style scoped>
</style>